module.exports = __webpack_public_path__ + "img/rang.9c78c156.png";